
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Responsible } from '@/model/Responsible';

@Component
export default class EventFlowLegend extends Vue {
    @Prop(Array) readonly responsibles!: Responsible[];

    get responsibleCountClass(): string {
        if (this.responsibles.length === 0) {
            return 'responsible-count-zero';
        }

        if (this.responsibles.length === 1) {
            return 'responsible-count-one';
        }

        if (this.responsibles.length === 2) {
            return 'responsible-count-two';
        }

        return '';
    }
}
